import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  message,
  notification,
  Select,
  Row,
  Col,
  InputNumber,
} from "antd";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";
import Datepicker from "../toolbox/DatePicker";
import DepoSelectOption from "../toolbox/DepoSelectOption";
import CurrencyInput from "../toolbox/CurrencyInput";
import { api } from "../../helpers/ApiHelper";
import strings from "../../utils/Localization";
import moment from "moment";
import DovizSelectOption from "../toolbox/DovizSelectOption";

const { Option } = Select;

const formSize = "middle";

function StokIslemDuzenleModal({ visible = false, handleCancel, data = null }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { stokIslemDuzenle: localization } = strings.stokIslem.components;

  useEffect(() => {
    if (data !== null) {
      form.setFieldsValue({
        id: data.id,
        tarih: moment(data.islemTarihi),
        girisMi: data.girisMi,
        depoId: String(data.stokDepoId),
        evrakNo: data.evrakNo,
        aciklama: data.aciklama,
        miktar: data.miktar,
        birimFiyat: data.birimFiyat,
        dovizId: String(data.Doviz.id),
      });
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const onFinish = async (values) => {
    try {
      const {
        id,
        tarih,
        girisMi,
        evrakNo,
        depoId,
        miktar,
        aciklama,
        birimFiyat,
        dovizId,
      } = values;
      setFetchLoading(true);

      const response = await api.put("/stokislem", {
        Id: id,
        StokDepoId: depoId,
        evrakNo: evrakNo,
        BirimFiyat: birimFiyat,
        Miktar: miktar,
        GirisMi: girisMi,
        Aciklama: aciklama,
        IslemTarihi: tarih,
        dovizId: dovizId,
      });
      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "stokIslemDuzenleModal",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
      centered
      width="50%"
    >
      <Form
        name="stokIslemDuzenleModal"
        form={form}
        onFinish={onFinish}
        layout="vertical"
        size={formSize}
      >
        <Row gutter={12}>
          <Col flex={1}>
            <Form.Item name="id" hidden />
            <Form.Item name="girisMi" hidden />
            <Form.Item
              name="tarih"
              label={localization.tarih}
              rules={[{ required: true }]}
            >
              <Datepicker />
            </Form.Item>
            <Form.Item
              name="girisMi"
              label={localization.islemTipi}
              rules={[{ required: true }]}
            >
              <Select>
                <Option value={true} style={{ color: "green" }}>
                  {localization.islemTipiSelect.giris}
                </Option>
                <Option value={false} style={{ color: "red" }}>
                  {localization.islemTipiSelect.cikis}
                </Option>
              </Select>
            </Form.Item>
            <DepoSelectOption
              formItemLabel={localization.depo}
              formItemName="depoId"
            />
          </Col>
          <Col flex={1}>
            <Form.Item name="evrakNo" label={localization.evrakNo}>
              <Input />
            </Form.Item>
            <Form.Item name="aciklama" label={localization.aciklama}>
              <Input.TextArea rows={5} />
            </Form.Item>
            <Row>
              <Form.Item
                name="birimFiyat"
                label="Birim Fiyat"
                style={{ flex: 1, marginRight: 8 }}
                rules={[{ required: true }]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <DovizSelectOption formItemName="dovizId" showKod required />
            </Row>
            <CurrencyInput
              required
              formItemLabel={localization.miktar}
              formItemName="miktar"
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default StokIslemDuzenleModal;
